/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessVoid } from '../models/SuccessVoid';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LabPreferenceControllerService {

    /**
     * Pauses the lab cadence for a configurable time period, with a default of 60 days
     * @returns SuccessVoid OK
     * @throws ApiError
     */
    public static pauseLabCadenceForOnboarding(): CancelablePromise<SuccessVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/labs/preferences/pause-cadence-onboarding',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
